import styled, {css} from 'styled-components';
import {device} from '../../styled/device';
import Webcam from '../Webcam';
import IconButton from '../common/IconButton';
import {DeviceCameraBlock} from './DeviceCamera/styled';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledWebcam = styled(Webcam)<{roundedScanArea?: boolean}>`
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 6;
  left: 0;
  top: 0;
  border-radius: 0;

  & .webcam__scan-area {
    height: 100%;
    max-height: 209px;

    @media (orientation: landscape) {
      max-height: 100%;
      height: 80%;
    }

    ${props =>
      props.roundedScanArea &&
      css`
        top: -60px;
        max-height: 55%;
        max-width: 80%;
        height: 100%;
        width: 100%;

        @media (max-width: ${device.mobileM}) {
          max-height: 369px;
          max-width: 261px;
          height: 100%;
          width: 100%;
        }

        @media (max-width: ${device.mobileS}) {
          max-height: 318px;
          max-width: 220px;
          height: 100%;
          width: 100%;
        }

        @media (orientation: landscape) {
          max-height: 90%;
          max-width: 261px;
          height: 100%;
          width: 100%;
        }
      `}
  }
`;

export const ButtonsSection = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 7;
  position: fixed;
  bottom: 20px;
  align-self: center;
  gap: 20px;

  width: calc(100% - 32px);
  justify-content: space-between;

  @media (orientation: landscape) {
    right: 40px;
    bottom: 0;
    top: 0;
    margin: auto;
    width: unset;
    justify-content: unset;
    height: unset;

    ${DeviceCameraBlock} {
      display: none;
    }
  }
`;

export const TakePhotoButton = styled(IconButton)`
  align-self: center;
  width: 75px;
  height: 75px;
  box-shadow: 0 0 10px #ffffff;

  & > img {
    width: 26px;
    height: 26px;
  }
`;

export const Title = styled.div`
  position: fixed;
  top: 32px;
  left: 50%;
  white-space: nowrap;
  transform: translate(-50%, 0);
  z-index: 7;
  color: white;
  font-size: 18px;
  font-weight: 700;

  @media (orientation: landscape) {
    top: 5px;
  }
`;

export const BackIconButton = styled.div`
  position: fixed;
  top: 36px;
  left: 28px;
  z-index: 7;

  @media (orientation: landscape) {
    top: 70px;
    left: 50px;
  }
`;

export const Subtitle = styled.p`
  position: fixed;
  top: 76px;
  color: white;
  z-index: 7;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;

  @media (orientation: landscape) {
    display: none;
  }

  @media (min-height: 838px) {
    top: 112px;
  }
`;

export const HelperText = styled.p`
  position: fixed;
  font-size: 12px;
  top: 88px;
  color: white;
  z-index: 7;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;

  @media (orientation: landscape) {
    display: none;
  }

  @media (min-height: 700px) {
    font-size: inherit;
  }
`;

export const AlertCameraText = styled.span`
  position: fixed;
  font-size: 12px;
  z-index: 7;
  width: 90%;
  border-radius: 6px;
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  align-items: center;
  border: 1px solid #e0b002;
  color: #e0b002;
  background-color: rgba(224, 176, 2, 0.2);
  top: 17%;
  padding: 4px 10px;

  & svg circle {
    fill: #e0b002;
  }
  & svg path {
    stroke: #e0b002;
  }

  @media (orientation: landscape) {
    display: none;
  }
`;
